import React, { useEffect, useState } from 'react'
import style from './TaxiBottomNavigation.module.css'
import { Link, useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClipboardList, faMapPin } from '@fortawesome/free-solid-svg-icons'
const TaxiBottomNavigation = () => {
    const location=useLocation()
    const[newRequestPageState,setNewPageRequestState]=useState(false)
    const[AllRequestPageState,setAllRequestPageState]=useState(true)

    
    useEffect(()=>{
        if(window.location.pathname==='/current')
        {
            setNewPageRequestState(true)
            setAllRequestPageState(false)

        }
        if(window.location.pathname==='/taxireqlist')
        {
            setNewPageRequestState(false)
            setAllRequestPageState(true)
 
        }
    },[location])
  return (
    <ul className={style.menufixed}>
    <Link to='/current' >
    <li className={newRequestPageState?style.menufixed__li__click: style.menufixed__li}> 
        <FontAwesomeIcon icon={faMapPin}/>
        <h2 className={style.h2}>سفرجدید</h2>
    </li>
    </Link>
    <Link to='/taxireqlist' >
    <li className={AllRequestPageState?style.menufixed__li__click: style.menufixed__li}>
        <FontAwesomeIcon  icon={faClipboardList}/>
        <h2 className={style.h2}>درخواست ها</h2> 
    </li>
    </Link>
</ul>
  )
}

export default TaxiBottomNavigation